module.exports = __webpack_public_path__ + "mobile.99730e29.png";